import { Link, useNavigate } from "react-router-dom";
import { Nav } from "../components/Nav";
import { ArrowLeft } from "lucide-react";
import { PageFooter } from "../components/PageFooter";

const Cancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Nav />
      <main
        data-testid="cancel-page"
        className="pt-32 px-5 sm:px-10 lg:px-14 max-w-2xl mx-auto pb-24 text-center"
      >
        <div className="kb-mono-label kb-blue">CHECKOUT CANCELLED</div>
        <h1 className="font-serif text-5xl mt-2 tracking-tight">
          No deposit taken.
        </h1>
        <p className="text-[var(--kb-fg-2)] mt-4 font-light">
          Your bag wasn’t reserved. You can pick it back up where you left off.
        </p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <button onClick={() => navigate("/ar")} className="kb-btn-primary">
            <ArrowLeft size={14} /> Back to AR Preview
          </button>
          <Link to="/shop" className="kb-btn-ghost">
            Home
          </Link>
        </div>
      </main>
      <PageFooter />
    </div>
  );
};

export default Cancel;
